<template>
  <div>
    <div class="row">
      <div class="col-12">
        <label class="font-w400">{{ translate[lang]["consumptionq1"] }}</label>
        <div class="form-group">
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="1"
              class="custom-control-input"
              id="consumptionStatus1"
              name="consumption[status]"
              v-model="cConsumptionStatus"
            />
            <label class="custom-control-label" for="consumptionStatus1">{{
              translate[lang]["yes"]
            }}</label>
          </div>
          <div class="custom-control custom-radio custom-control-inline">
            <input
              type="radio"
              value="2"
              class="custom-control-input"
              id="consumptionStatus2"
              name="consumption[status]"
              v-model="cConsumptionStatus"
            />
            <label class="custom-control-label" for="consumptionStatus2">{{
              translate[lang]["no"]
            }}</label>
          </div>
        </div>
      </div>
      <div
        class="col-md-12"
        v-if="cConsumptionStatus === '1' || cConsumptionStatus === '2'"
      >
        <div class="form-group form-row">
          <div class="col-md-12" v-if="cConsumptionStatus === '2'">
            <label>{{ translate[lang]["consumptionq3"] }}</label>
            <select
              class="form-control col-md-4"
              id="example-select2"
              name="products[electricity][solar][number_of_panels][clone2]"
              v-model="cFamilySituation"
              v-if="customertype == 1 || customertype == 2"
            >
              <option
                v-if="item.id <= 5"
                v-for="item in consumptions"
                :key="item.id"
                :value="item.id"
              >
                {{ item.description[lang] }}
              </option>
            </select>

            <select
              class="form-control"
              id="example-select2"
              name="products[electricity][solar][number_of_panels][clone2]"
              v-model="cFamilySituation"
              v-if="customertype == 9999"
            >
              <!-- <option value="0" selected disabled>
                {{ translate[lang]["pleaseselect"] }}
              </option> -->
              <option
                v-if="item.id > 5"
                v-for="item in consumptions"
                :key="item.id"
                :value="item.id"
              >
                {{ item.description[lang] }}
              </option>
            </select>
          </div>

          <div class="row" v-if="smartMeter == 0">
            <div
              class="col-md-12"
              v-if="meter == '1' && selectedProducts.includes(1)"
            >
              <label class="font-w400" style="font-size: 15px" for="singleLowKwh">{{
                translate[lang]["consumptionq2"]
              }}</label>
              <input
                type="number"
                id="singleLowKwh"
                class="form-control"
                placeholder="kWh"
                name="products[electricity][consumption][low]"
                onkeydown="javascript: return event.keyCode === 8 || event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                v-on:keyup="checkLimit(cConsumptionElectricitySingle, 'electricsinglelow')"
                v-model="cConsumptionElectricitySingle"
                required
                :readonly="cConsumptionStatus == '2'"
              />
            </div>
          </div>

          <div class="row">
            
            <div
              class="col-md-6 col-sm-12"
              v-if="smartMeter == 1 && selectedProducts.includes(1)"
            >
              <label class="font-w400" style="font-size: 15px" for="lowKwh2">{{ translate[lang]["consumption2o2"] }}</label>
              <input
                type="number"
                id="lowKwh2"
                class="form-control"
                placeholder="kWh"
                :min="min"
                :max="max"
                name="products[electricity][consumption][double][high]"
                v-on:keyup="
                  checkLimit(
                    cConsumptionElectricityDoubleHigh,
                    'electricsinglehigh'
                  )
                "
                v-model="cConsumptionElectricityDoubleHigh"
                required
                :readonly="cConsumptionStatus == '2'"
              />
            </div>
            
            <div
              class="col-md-6 col-sm-12"
              v-if="selectedProducts.includes(1) && smartMeter == 1"
            >
              <label class="font-w400" style="font-size: 15px" for="lowKwh1">{{ translate[lang]["consumption2o1"] }}</label>
              <input
                type="number"
                id="lowKwh1"
                class="form-control"
                placeholder="kWh"
                :min="min"
                :max="max"
                name="products[electricity][consumption][double][low]"
                v-on:keyup="
                  checkLimit(
                    cConsumptionElectricityDoubleLow,
                    'electricdoublelow'
                  )
                "
                v-model="cConsumptionElectricityDoubleLow"
                required
                :readonly="cConsumptionStatus == '2'"
              />
            </div>
            
          </div>

        </div>

        <div class="form-group form-row">
        
  
          <div class="row">
            <div class="col-12 mt-2" v-if="selectedProducts.includes(2)">
              <label class="font-w400" style="font-size: 15px" for="normalKwh">{{
                translate[lang]["consumption2o3"]
              }}</label>
              <input
                type="number"
                id="normalKwh"
                class="form-control"
                placeholder="M³"
                onkeydown="javascript: return event.keyCode === 8 ||
                event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                name="products[gas][consumption]"
                v-on:keyup="checkLimit(cComsumptionGas, 'consumptiongas')"
                v-model="cComsumptionGas"
                required
                :readonly="cConsumptionStatus == '2'"
              />
            </div>
            <br>
          </div>
          
        </div>
        
      </div>

      <!-- <div class="col-md-12" v-if="cConsumptionStatus === '2'"></div> -->
    </div>
    
    <div
      class="modal fade"
      id="moreinfo2"
      role="dialog"
      aria-labelledby=""
      aria-hidden="true"
    >
      <Dialog :content="modalcontent" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import Dialog from "../dialog";
export default {
  name: "Consumption",
  data() {
    return {
      min: 1,
      max: 10000000,
      modalcontent: {
        title: null,
        description: null,
      },
    };
  },
  components: { Dialog },
  async created() {
    await this.getConsumptionList().then(() => {});

    if(this.$route.query.household && this.$route.query.household < 6) {
      this.setFamilySituation(this.$route.query.household);
      this.setConsumption();
    }

  },
  computed: {
    ...mapState({
      consumptions: (state) => state.forms.consumptions,
      familySituation: (state) => state.forms.consumption.familySituation,
      consumptionStatus: (state) => state.forms.consumption.status,
      consumptionElectricitySingle: (state) =>
        state.forms.consumption.electric.single,
      consumptionElectricityLow: (state) =>
        state.forms.consumption.electric.low,
      consumptionElectricityHigh: (state) =>
        state.forms.consumption.electric.high,
      consumptionElectricityDoubleLow: (state) =>
        state.forms.consumption.electric.double.low,
      consumptionElectricityDoubleHigh: (state) =>
        state.forms.consumption.electric.double.high,
      comsumptionGas: (state) => state.forms.consumption.gas,
      meter: (state) => state.forms.meter,
      smartMeter: (state) => state.forms.smartMeter,
    }),
    cFamilySituation: {
      get() {

        return this.familySituation;
      },
      set(val) {
        this.setFamilySituation(val);
        this.setConsumption();
      },
    },
    cConsumptionStatus: {
      get() {

        return this.consumptionStatus;
      },
      set(val) {

        this.setConsumptionStatus(val);
        if (val == 2) {
          this.setConsumption();
        }
      },
    },
    cConsumptionElectricitySingle: {
      get() {
        if(this.$route.query.kwhSingle) {
          this.setElectricitySingle(this.$route.query.kwhSingle);
          return this.$route.query.kwhSingle
        }
        return this.consumptionElectricitySingle;
      },
      set(val) {
        this.setElectricitySingle(val);
      },
    },
    cConsumptionElectricitySingleLow: {
      get() {
        if(this.$route.query.cConsumptionElectricitySingleLow) {
          this.setElectricitySingleLow(this.$route.query.cConsumptionElectricitySingleLow);
          return this.$route.query.cConsumptionElectricitySingleLow
        }
        return this.consumptionElectricityLow;
      },
      set(val) {
        this.setElectricitySingleLow(val);
        this.setElectricitySingle(
          parseInt(val) + parseInt(this.consumptionElectricityHigh)
        );
      },
    },
    cConsumptionElectricitySingleHigh: {
      get() {
        if(this.$route.query.consumptionElectricityHigh) {
          this.setElectricitySingleHigh(this.$route.query.consumptionElectricityHigh);
          return this.$route.query.consumptionElectricityHigh
        }
        return this.consumptionElectricityHigh;
      },
      set(val) {
        this.setElectricitySingleHigh(val);
        this.setElectricitySingle(
          parseInt(val) + parseInt(this.consumptionElectricityLow)
        );
      },
    },
    cConsumptionElectricityDoubleLow: {
      get() {
        if(this.$route.query.kwhDoubleLow) {
          this.setElectricityDoubleLow(this.$route.query.kwhDoubleLow);
          return this.$route.query.kwhDoubleLow
        }
        return this.consumptionElectricityDoubleLow;
      },
      set(val) {
        this.setElectricityDoubleLow(val);
      },
    },
    cConsumptionElectricityDoubleHigh: {
      get() {
        if(this.$route.query.kwhDoubleHigh) {
          this.setElectricityDoubleHigh(this.$route.query.kwhDoubleHigh);
          return this.$route.query.kwhDoubleHigh
        }
        return this.consumptionElectricityDoubleHigh;
      },
      set(val) {
        this.setElectricityDoubleHigh(val);
      },
    },
    cComsumptionGas: {
      get() {
        if(this.$route.query.m3) {
          this.setGas(this.$route.query.m3);
          return this.$route.query.m3
        }
        return this.comsumptionGas;
      },
      set(val) {
        this.setGas(val);
      },
    },
  },
  watch: {
    familySituation: {
      handler: function () {
        if (this.consumptionStatus == 2) {
          this.setConsumption();
        }
      },
      deep: true,
    },
    form(val) {

      if (!this.isSubmittedForm) {
        if (val.data.customertype === 1) {
          //this.setFamilySituation(1);
        } else {
          this.setFamilySituation(6);
        }
      }
    },
    // postcodeQuery(val){
    //   if(!this.isSubmittedForm){
    //     if(val !== null){
    //       if(val.gebruiksdoelen === 1){
    //         this.setFamilySituation(1)
    //       }else{
    //           this.setFamilySituation(6)
    //       }
    //     }
    //   }
    // }
  },
  methods: {
    ...mapActions({
      getConsumptionList: "forms/getConsumptionList",
    }),
    ...mapMutations({
      setConsumptionStatus: "forms/SET_CONSUMPTION_STATUS",
      setElectricityDoubleLow: "forms/SET_ELECTRICITY_LOW",
      setElectricityDoubleHigh: "forms/SET_ELECTRICITY_HIGH",
      setElectricitySingle: "forms/SET_ELECTRICITY_SINGLE",
      setElectricitySingleLow: "forms/SET_ELECTRICITY_SINGLE_LOW",
      setElectricitySingleHigh: "forms/SET_ELECTRICITY_SINGLE_HIGH",
      setGas: "forms/SET_GAS",
      setFamilySituation: "forms/SET_FAMILY_SITUATION",
    }),
    setConsumption() {
      let consumption = this.consumptions.filter(
        (x) => x.id == this.familySituation
      )[0];
      this.setElectricitySingleLow(
        consumption.electric.double.low
          ? parseInt(consumption.electric.double.low)
          : 1
      );
      this.setElectricitySingleHigh(
        consumption.electric.double.high
          ? parseInt(consumption.electric.double.high)
          : 1
      );
      this.setElectricitySingle(
        parseInt(this.consumptionElectricityLow) +
          parseInt(this.consumptionElectricityHigh)
      );
      this.setElectricityDoubleLow(
        consumption.electric.double.low
          ? parseInt(consumption.electric.double.low)
          : 1
      );
      this.setElectricityDoubleHigh(
        consumption.electric.double.high
          ? parseInt(consumption.electric.double.high)
          : 1
      );
      this.setGas(parseInt(consumption.gas));
    },
    checkLimit(item, type) {
      if (item === "") {
        return;
      } else if (item > this.max) {
        if (type === "electricsingle") {
          this.$store.state.forms.consumption.electric.single =
            this.max.toString();
        }
        if (type === "electricdoublelow") {
          this.$store.state.forms.consumption.electric.double.low =
            this.max.toString();
        }
        if (type === "electricsinglehigh") {
          this.$store.state.forms.consumption.electric.double.high =
            this.max.toString();
        }
        if (type === "consumptiongas") {
          this.$store.state.forms.consumption.gas = this.max.toString();
        }
      } else if (item <= 0 || !parseInt(item)) {
        if (type === "electricsingle") {
          this.$store.state.forms.consumption.electric.single =
            this.min.toString();
        }
        if (type === "electricdoublelow") {
          this.$store.state.forms.consumption.electric.double.low =
            this.min.toString();
        }
        if (type === "electricsinglehigh") {
          this.$store.state.forms.consumption.electric.double.high =
            this.min.toString();
        }
        if (type === "consumptiongas") {
          this.$store.state.forms.consumption.gas = this.min.toString();
        }
      }
    },
  },
};
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
